import { render, staticRenderFns } from "./CommandsIndicator.vue?vue&type=template&id=36febddc&scoped=true&lang=pug&"
import script from "./CommandsIndicator.vue?vue&type=script&lang=js&"
export * from "./CommandsIndicator.vue?vue&type=script&lang=js&"
import style0 from "./CommandsIndicator.vue?vue&type=style&index=0&id=36febddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36febddc",
  null
  
)

export default component.exports